import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Container from "../../components/Container";

const ContentGenerations = () => {
  return (
    <Container
      page={"content-generations"}
      searchVal={""}
      onSearch={() => null}
      searchLabel=""
    >
      <Box sx={styles.wrap}>
        <Typography sx={styles.title}>Content Generations</Typography>
        <Typography sx={styles.subtitle}>
          Coming soon — generate content here.
        </Typography>
      </Box>
    </Container>
  );
};

export default ContentGenerations;

const styles = {
  wrap: { p: 1 },
  title: { fontFamily: "GilroyBold", fontSize: 20, color: "#1F2A1A" },
  subtitle: {
    fontFamily: "GilroyRegular",
    fontSize: 14,
    color: "#7A8A72",
    mt: 1,
  },
};
